import { Button, Col, Container, Form, Row } from 'react-bootstrap'

import { useYupForm } from '../../../hooks'
import schema from './schema'
import { FormInput, FormPassword } from '../../formControl'

const AccountSeeting = () => {
  const defaultValue = {
    firstName: 'Alberto',
    lastName: 'Damien',
    email: 'ablerto@bohemain.cc',
    password: '12345678'
  }

  const useForm = useYupForm(schema, defaultValue)
  const { handleSubmit, formState: { errors }, register } = useForm
  return (
    <Container style={{ maxWidth: '400px' }} className='mt-5'>
      <Row className='py-5 text-center max-vh-100 login'>
        <Col sm={12} className='my-0 mx-auto'>
          <div className='fs-small'>
            <strong className='d-block'>
              Account settings
            </strong>
          </div>
          <Form
            className='form form-default py-4 px-3 mt-3'
            onSubmit={handleSubmit()}
          >
            <FormInput
              basic
              label='First Name'
              placeholder='Enter First Name'
              error={!!errors.firstName}
              errorMessage={errors.firstName?.message}
              wrapperClass='mb-3'
              {...register('firstName')}
            />
            <FormInput
              basic
              label='Last Name'
              placeholder='Enter Last Name'
              error={!!errors.lastName}
              errorMessage={errors.lastName?.message}
              wrapperClass='mb-3'
              {...register('lastName')}
            />
            <FormInput
              basic
              label='Email'
              placeholder='Enter email'
              error={!!errors.email}
              errorMessage={errors.email?.message}
              wrapperClass='mb-3'
              {...register('email')}
            />
            <FormPassword
              basic
              type='password'
              label='Password'
              placeholder='Enter password'
              error={!!errors.password}
              errorMessage={errors.password?.message}
              togglePassword
              {...register('password')}
            />
            <Button className='w-100 mt-4 text-uppercase' type='submit'>
              Save
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  )
}
export default AccountSeeting